import { List } from 'immutable';

export const isLoadingDonations = state => state.getIn(['donations', 'loading']) || false;
export const selectDonations = state => state.getIn(['donations', 'donationsList']) || new List();
export const selectHasFetchedDonations = state => state.getIn(['donations', 'hasFetched']) || false;
export const selectDonationsError = state => state.getIn(['donations', 'error']) || false;
